import React from 'react';

import { FullWidthAutoHeightImage } from 'components/picture';

export const HeaderFlair = () => (
  <FullWidthAutoHeightImage
    style={{ position: 'absolute', top: 0 }}
    source={require('./pdp-header-flair.webp')}
  />
);
